﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const tmpls_1 = require("./classes/com/tmpls");
const gs_1 = require("@ivanlog/gs");
const AppVX_1 = require("./classes/AppVX");
gs_1.FormGS.TagClassName = 'up-form';
gs_1.WrapperGS.ExtendComponentsByTagClass(gs_1.FormGS);
modalCom.Implement();
modalCom.AbstractDialog.HtmlTemplate = (new tmpls_1.CmpModalDialog).el.outerHTML;
globalThis.app = new AppVX_1.AppVX();
//# sourceMappingURL=index.js.map